import MenuItemPizza from './MenuItemPizza'
import MenuItemPizzaAmount from './MenuItemPizzaAmount'

export { MenuItemPizzaAmount }

export default MenuItemPizza
